
import { defineComponent } from 'vue';
import ItemDeOpcao from './ItemDeOpcao.vue';
import AdicionarOpcao from './AdicionarOpcao.vue';
import { OpcaoEditavel } from '@/dominio/editor/questoes/questao-opcao/opcao/OpcaoEditavel';
import { ListaEditavel } from '@/dominio/editor/comum/ListaEditavel';

export default defineComponent({
    name: 'ListaOpcoes',
    components: {
        ItemDeOpcao,
        AdicionarOpcao,
    },
    props: {
        lista: {
            type: ListaEditavel,
            required: true,
        },
    },
    data() {
        return {
            estaLista: this.lista as ListaEditavel<OpcaoEditavel>,
        };
    },
    computed: {
        itensOrdenados(): OpcaoEditavel[] {
            const retorno = (this.lista as ListaEditavel<OpcaoEditavel>)
                .getItens()
                .sort((a, b) => {
                    const indiceA = a.getIndice();
                    const indiceB = b.getIndice();
                    if (indiceA < indiceB) {
                        return -1;
                    }
                    if (indiceA > indiceB) {
                        return 1;
                    }
                    return 0;
                });
            return retorno;
        },
    },
    methods: {
        editar(item: OpcaoEditavel) {
            this.estaLista.editarItem(item);
        },
        adicionarItem(item: OpcaoEditavel) {
            this.estaLista.adicionarItem(item);
        },
        excluir(item: OpcaoEditavel) {
            this.estaLista.excluirItem(item);
        },
        descer(item: OpcaoEditavel) {
            this.estaLista.descerItem(item);
        },
        subir(item: OpcaoEditavel) {
            this.estaLista.subirItem(item);
        },
    },
});
